module.exports = __webpack_public_path__ + "img/P2-en.73f01407.png";